import axios from 'axios';

export const api = axios.create({
  baseURL: //'http://10.0.1.167:8597',
            //'http://10.3.3.4:8597',
           'https://app.florestasm.com.br:8597',
           //timeout: 60000,
  auth: {
    username: 'floresta',
    password: 'floresta!!'
  },
  //withCredentials: true
});